import { useLocation } from 'react-router-dom';

export enum OrderBoardType {
  ALL,
  SHIP_WEEK,
  ASAP,
}

export const useOrderBoardType = (): OrderBoardType => {
  const { pathname } = useLocation();

  if (pathname.endsWith('/shipweek')) {
    return OrderBoardType.SHIP_WEEK;
  }

  if (pathname.endsWith('/asap')) {
    return OrderBoardType.ASAP;
  }

  return OrderBoardType.ALL;
};
